<div class="response table-responsive m-b-2">
    <table class="est-table building-table" cellspacing="0">
        <thead>
            <th>Property Uid</th>
            <th>Property Name</th>
            <th>House Number</th>
            <th>Neigh Name</th>
            <th>Block Name</th>
            <th>Land Area (sqm)</th>
            <th>Property Grade</th>
            <th>Build Year</th>
            <th>Property Cat Subcat</th>
            <th>Property Sub Cat</th>
            <th>Parcel Uid</th>
            <th>Floors</th>
            <th>Units</th>
            <th>Govern Name</th>
            <th>Year</th>
            <th>Street Name</th>
            <th>Zoning</th>
            <th>Ref No</th>
            <th>Parcel No</th>
            <th>Project Name</th>
            <th>Amenities</th>
            <th>Survey Block</th>
            <th>Retail Area (sqm)</th>
            <th>Office Area (sqm)</th>
            <th>Residential Area (sqm)</th>
            <th>Parking Area (sqm)</th>
            <th>Hospitality Area (sqm)</th>
            <th>Storage Area (sqm)</th>
            <th>Build Status</th>
            <th>Far Actual</th>
            <th>Far Permissible</th>
            <th>Usage</th>
            <th>Property Age</th>
            <th>Developer</th>
            <th>Construction Expected Date</th>
            <th>Plan No</th>
            <th>Setback Area</th>
            <th>Frontage</th>
            <th>Corner</th>
            <th>Direction Info</th>

        </thead>
            <tbody>
                @for (item of tableData; track $index) {
                    <tr>
                        <td>{{item.property_uid || '-'}}</td>
                        <td>{{item.property_name || '-'}}</td>
                        <td>{{item.house_no || '-'}}</td>
                        <td>{{item.neigh_name || '-'}}</td>
                        <td>{{item.block_name || '-'}}</td>
                        <td>{{item.land_area ? (item.land_area | number : '1.0-1') : '-'}}</td>
                        <td>{{item.property_grade || '-'}}</td>
                        <td>{{item.build_year ? (item.build_year | date:'yyyy') : '-'}}</td>
                        <td><span class="property-cat-col" title="{{item.property_cat_subcat}}">{{item.property_cat_subcat || '-'}}</span></td>
                        <td><span class="property-cat-col" title="{{item.property_sub_cat}}">{{item.property_sub_cat || '-'}}</span></td>
                        <td>{{item.parcel_uid || '-'}}</td>
                        <td>{{item.floors || '-'}}</td>
                        <td>{{item.units || '-'}}</td>
                        <td>{{item.govern_name || '-'}}</td>
                        <td>{{item.year || '-'}}</td>
                        <td>{{item.street_name || '-'}}</td>
                        <td>{{item.zoning || '-'}}</td>
                        <td>{{item.ref_no || '-'}}</td>
                        <td>{{item.parcel_no || '-'}}</td>
                        <td>{{item.project_name || '-'}}</td>
                        <td>{{item.amenities || '-'}}</td>
                        <td>{{item.survey_block || '-'}}</td>
                        <td>{{item.retail_area ? (item.retail_area | number : '1.0-1') : '-'}}</td>
                        <td>{{item.office_area ? (item.office_area | number : '1.0-1') : '-'}}</td>
                        <td>{{item.residential_area ? (item.residential_area | number : '1.0-1') : '-'}}</td>
                        <td>{{item.parking_area ? (item.parking_area | number : '1.0-1') : '-'}}</td>
                        <td>{{item.hospitality_area ? (item.hospitality_area | number : '1.0-1') : '-'}}</td>
                        <td>{{item.storage_area ? (item.storage_area | number : '1.0-1') : '-'}}</td>
                        <td>{{item.build_status || '-'}}</td>
                        <td>{{item.far_actual ? (item.far_actual | number : '1.0-1') : '-'}}</td>
                        <td>{{item.far_permissible ? (item.far_permissible | number : '1.0-1') : '-'}}</td>
                        <td>{{item.usage || '-'}}</td>
                        <td>{{item.property_age || '-'}}</td>
                        <td>{{item.developer || '-'}}</td>
                        <td>{{item.construction_expected_date ? (item.construction_expected_date | date :'dd-MMM-YYYY') : '-'}}</td>
                        <td>{{item.plan_no || '-'}}</td>
                        <td>{{item.setback_area ? (item.setback_area | number : '1.0-1') : '-'}}</td>
                        <td>{{item.frontage ? (item.frontage | number : '1.0-1') : '-'}}</td>
                        <td>{{item.corner ? (item.corner | number : '1.0-1') : '-'}}</td>
                        <td>{{item.direction_info ? (item.direction_info | json) : '-'}}</td>
                    </tr>
                    }
            </tbody>
    </table>

</div>
<div>
    @if(response){
        <app-table-pagination [tableData]="response" [itemsPerPage]="10" (filterData)="updateRecord($event)"></app-table-pagination>
    }
</div>
